import React from 'react'
import { EcomDataLayerHub } from '../../javascript/analytics/ecommerceDataLayerEventHub.services'
import { IEpiProps, StepConstants } from '../models/event-reg-refresh-models'
import { useEventRegRefreshContext, useEventRegRefreshDispatch } from '../reducers/event-reg-refresh-reducers'
import { ContentWrapper } from './layout/content-wrapper'
import { MainContent } from './layout/main-content'

interface IContextProps {
  epiProps: IEpiProps
  currentStep: string
  userSelections: IUserSelections
}

interface IProps {
  showEditCta: boolean
}

export const AttendeesReview = (props: IProps) => {
  const { currentStep, epiProps, userSelections }: IContextProps = useEventRegRefreshContext()!
  const dispatch = useEventRegRefreshDispatch()!

  function navigateToStep(step: string) {
    dispatch({
      type: 'updateCurrentStep',
      data: step,
    })
  }

  if (userSelections.attendees && userSelections.attendees.length > 0) {
    return (
      <div className="card">
        <div className="card-header">
          <div className="card-header-content">
            <h4>{epiProps.attendeesHeadingReview}</h4>
          </div>
          {props.showEditCta && (
            <button
              className="btn-tertiary"
              onClick={() => {
                navigateToStep(StepConstants.AttendeesStep)
                EcomDataLayerHub.reviewEditClick('Attendee')
              }}
            >
              {epiProps.editSelectionCtaText}
            </button>
          )}
        </div>
        <ul className="attendees-review-list">
          {userSelections.attendees.map((attendee: IAttendee, index: number) => (
            <li className="attendees-review-list-item" key={index}>
              <p className="attendees-review-list-item-value">
                {attendee.firstName} {attendee.lastName}
              </p>
              <p className="attendees-review-list-item-value">{attendee.title}</p>
              <p className="attendees-review-list-item-value attendees-review-list-item-email">{attendee.email}</p>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}
